"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = exports.usePortal = void 0;
var react_1 = require("react");
var react_dom_1 = require("react-dom");
function createRootElement(id) {
    var el = document.createElement('div');
    el.setAttribute('id', id);
    document.body.appendChild(el);
    return el;
}
function usePortal(id) {
    var _a = (0, react_1.useState)(null), container = _a[0], setContainer = _a[1];
    (0, react_1.useLayoutEffect)(function () {
        var existingParent = document.querySelector("#".concat(id));
        var el = existingParent || createRootElement(id);
        setContainer(el);
    }, []);
    return container;
}
exports.usePortal = usePortal;
function Portal(props) {
    var name = props.name, children = props.children;
    var container = usePortal(name);
    if (!container) {
        return null;
    }
    return (0, react_dom_1.createPortal)(children, container);
}
exports.Portal = Portal;
//# sourceMappingURL=portal.js.map